@if (loaded) {
  <section>
    <div class="row" [formGroup]="form">
      @if (numerisations_list?.length > 0) {
        <div class="col-md-6 mb-3">
          <label class="w-100">
            <span class="super-compos-label-input">{{ 'iScan.globalInfos.scanningCenter' | translate }}</span>
            <p-dropdown
              styleClass="w-100"
              formControlName="centreNum"
              [options]="numerisations_list | sort: 'label' : 'ASC'"
              [placeholder]="'iScan.action.selectScanningCenter' | translate"
              [showClear]="true"
              appendTo="body"
              (onChange)="updateFieldQRcodeCentreNum($event.value)"></p-dropdown
          ></label>
        </div>
      }
      <div class="col-md-6 mb-3 p-fluid">
        <label for="p-treeSelect-separator-page" class="w-100">
          <span class="super-compos-label-input">{{ 'iScan.globalInfos.service' | translate }}</span>
          <p-treeSelect
            id="p-treeSelect-separator-page"
            class="treeSelect"
            [emptyMessage]="'iScan.information.noResultFound' | translate"
            [options]="rightToShowAllServices ? serviceParentChild : servicesOnlyParents"
            #treeSelect
            selectionMode="single"
            [placeholder]="'iScan.action.pleaseSelectAService' | translate"
            appendTo="body"
            (onNodeSelect)="select($event)"
            [filter]="true"
            [filterPlaceholder]="'global.filterPlaceholder' | translate"
            [filterBy]="'label'"
            [filterMode]="'strict'"
            [metaKeySelection]="false"></p-treeSelect>
        </label>
      </div>
      <div class="col-md-4 mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'iScan.globalInfos.source' | translate }}</span>
          <p-dropdown
            styleClass="w-100"
            formControlName="sourceId"
            [options]="sources | sort: 'label' : 'ASC'"
            [placeholder]="'iScan.action.selectSource' | translate"
            [showClear]="true"
            appendTo="body"
            (onChange)="updateFieldQRcodeSource($event.value)"></p-dropdown
        ></label>
      </div>
      <div class="col-md-4 mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'iScan.globalInfos.destinataire' | translate }}</span>
          <p-dropdown
            styleClass="w-100"
            formControlName="destinataireContactId"
            [options]="destinataires | sort: 'label' : 'ASC'"
            optionLabel="name"
            optionValue="id"
            [placeholder]="'iScan.action.selectRecipient' | translate"
            [showClear]="true"
            appendTo="body"
            (onChange)="updateFieldQRcodeRecipient($event.value)"
            [virtualScroll]="true"
            [filter]="true"
            virtualScrollItemSize="30"></p-dropdown
        ></label>
      </div>
      <div class="col-md-4 mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'iScan.globalInfos.classificationCode' | translate }}</span>
          <p-dropdown
            styleClass="w-100"
            formControlName="classificationCode"
            [options]="classificationCodes | sort: 'label' : 'ASC'"
            [placeholder]="'iScan.action.selectClassificationCode' | translate"
            [showClear]="true"
            appendTo="body"
            (onChange)="updateFieldQRcodeClassificationCode($event.value)"
            [virtualScroll]="true"
            [filter]="true"
            virtualScrollItemSize="30"></p-dropdown
        ></label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 d-flex flex-column justify-content-center align-items-center">
        <input type="text" class="form-control" placeholder="{{ 'iScan.information.codeQR' | translate }}" [(ngModel)]="qrcodeText" />
        <i-button (click)="openQRCODE()" text="Générer" styleClass="green mt-3"></i-button>
      </div>
      <div class="col-md-12 text-center qrcodeDiv">
        <qrcode [qrdata]="qrcodeText" [allowEmptyString]="true" [width]="256" [errorCorrectionLevel]="'M'" [elementType]="'img'"></qrcode>
      </div>
    </div>
  </section>
}
@if (!loaded) {
  <div class="loader_div">
    <i-loader [size]="100" [text]="'loading' | translate"></i-loader>
  </div>
}
